<script>
    import { fade,slide } from 'svelte/transition';
    import PasswordStrength from "svelte-password-strength-bar";
    import { bookOneCourseOrganisation } from '/public/services/courses.js';

    export let course;
    export let obj;
    export let provinces;
    
    let showProvince = true;   
    let showPhysicalProvince = true;   

    function doSubmit(e) {
        e.preventDefault();

        bookOneCourseOrganisation(course.id, obj).then(res => {
            if (res.success) {
                window.location = res.data.url;
            }
        });
    }

    function selectProvince(pro) {
        obj.province_id = pro.id;
        obj.province_name = pro.title;
        showProvince = false;
    }

    function selectPhysicalProvince(pro) {
        obj.physical_province_id = pro.id;
        obj.physical_province_name = pro.title;
        showPhysicalProvince = false;
    }

</script>
<form class='form' on:submit={doSubmit}>
    <fieldset>
        <legend>
            Your Information
        </legend>
        <p class='form-text text-muted'>
            <span class='fas fa-info-circle'></span> We need your details so that we can create an account for you.
        </p>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='first'>
                First Name <span class='fas fa-asterisk text-danger'></span>
            </label>
            <div class='col-sm-9'>
                <input 
                    type='text'
                    class='form-control'
                    bind:value={obj.first_name}
                    required
                    placeholder="What is your first name?"
                    class:is-invalid='{obj.first_name == null}'
                />
            </div>
        </div>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='last'>
                Last Name <span class='fas fa-asterisk text-danger'></span>
            </label>
            <div class='col-sm-9'>
                <input 
                    type='text'
                    class='form-control'
                    bind:value={obj.last_name}
                    required
                    placeholder="What is your last name?"
                    class:is-invalid='{obj.last_name == null}'
                />
            </div>
        </div>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='email'>
                Email  <span class='fas fa-asterisk text-danger'></span>
            </label>
            <div class='col-sm-9'>
                <div class='input-group'>
                    <div class='input-group-text'>
                        <span class='fas fa-envelope'></span>
                    </div>
                    <input 
                        type='email'
                        class='form-control'
                        bind:value={obj.email}
                        required
                        placeholder="What is your email?"
                        class:is-invalid='{obj.email == null}'
                    />
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-sm-3 col-form-label" for="password">
                Password
            </label>
            <div class="col-sm-9">
                <input id="password" type="password" bind:value={obj.password} class="form-control" placeholder="Enter password - min 8 chars" required/>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-sm-3 col-form-label" for="password_confirmation">
                Password Confirmation
            </label>
            <div class="col-sm-9">
                <input id="password_confirmation" type="password" bind:value={obj.password_confirmation} class="form-control" placeholder="And again" required/>
            </div>
        </div>

        {#if obj.password != null}

            <div class='row mb-3' in:slide>
                <label class='col-form-label col-sm-3' for='strength'>
                    Password Strength
                </label>
                <div class='col-sm-9'>
        
                    <PasswordStrength password={obj.password}/>
        
                </div>
            </div>

        {/if}

        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='phone'>
                Phone
            </label>
            <div class='col-sm-9'>
                <div class='input-group'>
                    <div class='input-group-text'>
                        <span class='fas fa-phone'></span>
                    </div>
                    <input 
                        type='text'
                        class='form-control'
                        bind:value={obj.phone}                            
                        placeholder="Optional phone number"                            
                    />
                </div>
            </div>
        </div>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='mobile'>
                Mobile
            </label>
            <div class='col-sm-9'>
                <div class='input-group'>
                    <div class='input-group-text'>
                        <span class='fas fa-mobile'></span>
                    </div>
                    <input 
                        type='text'
                        class='form-control'
                        bind:value={obj.mobile}                            
                        placeholder="Optional mobile number"                            
                    />
                </div>
            </div>
        </div>
    </fieldset>
    <fieldset>
        <legend>
            Organisation Information
        </legend>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='first'>
                Title <span class='fas fa-asterisk text-danger'></span>
            </label>
            <div class='col-sm-9'>
                <input 
                    type='text'
                    class='form-control'
                    bind:value={obj.title}
                    required
                    placeholder="Organisation title"
                    class:is-invalid='{obj.title == null}'
                />
            </div>
        </div>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='address1'>
                Address 1 <span class='fas fa-asterisk text-danger'></span>
            </label>
            <div class='col-sm-9'>                    
                <input 
                    type='text'
                    class='form-control'
                    bind:value={obj.address1}                            
                    placeholder="Address One"    
                    required
                    class:is-invalid='{obj.address1 == null}'                        
                />                    
            </div>
        </div>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='address2'>
                Address 2
            </label>
            <div class='col-sm-9'>                    
                <input 
                    type='text'
                    class='form-control'
                    bind:value={obj.address2}                            
                    placeholder="Optional Address Two"                            
                />                    
            </div>
        </div>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='suburb'>
                Suburb
            </label>
            <div class='col-sm-9'>                    
                <input 
                    type='text'
                    class='form-control'
                    bind:value={obj.suburb}                            
                    placeholder="Optional Suburb"                            
                />                    
            </div>
        </div>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='city'>
                City <span class='fas fa-asterisk text-danger'></span>
            </label>
            <div class='col-sm-9'>                    
                <input 
                    type='text'
                    class='form-control'
                    bind:value={obj.city}                            
                    placeholder="City"                            
                    required
                    class:is-invalid='{obj.city == null}'
                />                    
            </div>
        </div>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='postcode'>
                Postcode <span class='fas fa-asterisk text-danger'></span>
            </label>
            <div class='col-sm-9'>                    
                <input 
                    type='text'
                    class='form-control'
                    bind:value={obj.postcode}                            
                    placeholder="Postcode"                            
                    required
                    class:is-invalid='{obj.postcode == null}'
                />                    
            </div>
        </div>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='postcode'>
                Province <span class='fas fa-asterisk text-danger'></span>
            </label>
            <div class='col-sm-9'>    
                {#if showProvince === false}
                    <div class='clearfix'>

                        <button type='button' class='btn btn-outline-primary btn-sm float-end ms-2' on:click={() => showProvince = true}>
                            <span class='fas fa-edit'></span> Edit Province
                        </button>

                        <span class='fas fa-map-marker-alt'></span> { obj.province_name }

                    </div>
                
                {:else}
                    
                    <div class='list-group' in:fade out:fade>

                        {#if obj.province_id != null}

                            <div class='list-group-item text-end'>
                                <button type='button' class='btn btn-outline-secondary' on:click={() => showProvince = false}>
                                    <span class='fas fa-times-circle'></span> Cancel
                                </button>
                            </div>

                        {/if}

                        {#each provinces as po}

                            <div
                                class='list-group-item js-button'
                                on:click={() => selectProvince(po)}
                                on:keypress={() => selectProvince(po)}
                                class:active='{obj.province_id == po.id}'
                                role='button'
                                tabindex='0'
                            >

                                {#if obj.province_id == po.id}
                                    
                                    <span class='fas fa-check-circle me-2' in:fade out:fade></span>

                                {/if}

                                { po.title }

                            </div>

                        {/each}

                    </div>   
                    
                {/if}

            </div>
        </div>
        <div class='row mb-3'>
            <label class='col-sm-3 col-form-label' for='country'>
                Country <span class='fas fa-asterisk text-danger'></span>
            </label>
            <div class='col-sm-9'>                    
                <input 
                    type='text'
                    class='form-control'
                    bind:value={obj.country}                            
                    placeholder="Optional Country"    
                    required
                    class:is-invalid='{obj.country == null}'                        
                />                    
            </div>
        </div>
    </fieldset>
    <fieldset>
        <legend>
            Physical Address
        </legend>
        <div class='row mb-3'>
            <div class='col-sm-12'>
                <div class='list-group'>
                    <div 
                        class='list-group-item js-button'
                        on:click={() => obj.has_physical_address = true}
                        on:keypress={() => obj.has_physical_address = true}
                        class:active='{obj.has_physical_address === true}'
                        role='button'
                        tabindex='0'
                    >
                        {#if obj.has_physical_address === true}

                            <span class='fas fa-check-circle text-success me-3' in:fade out:fade></span>

                        {/if}
                        Yes, my organisation has a different physical address
                    </div>
                    <div 
                        class='list-group-item js-button'
                        on:click={() => obj.has_physical_address = false}
                        on:keypress={() => obj.has_physical_address = false}
                        class:active='{obj.has_physical_address === false}'
                        role='button'
                        tabindex='0'
                    >
                        {#if obj.has_physical_address === false}

                            <span class='fas fa-times-circle text-danger me-3' in:fade out:fade></span>

                        {/if}
                        No, my organisation only has one address
                    </div>
                </div>
            </div>
        </div>

        {#if obj.has_physical_address === true}

            <div in:slide out:slide>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='physical_address1'>
                        Address 1 <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.physical_address1}                            
                            placeholder="Address One"    
                            required
                            class:is-invalid='{obj.physical_address1 == null}'                        
                        />                    
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='physical_address2'>
                        Address 2
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.physical_address2}                            
                            placeholder="Optional Address Two"                            
                        />                    
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='physical_suburb'>
                        Suburb
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.physical_suburb}                            
                            placeholder="Optional Suburb"                            
                        />                    
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='physical_city'>
                        City <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.physical_city}                            
                            placeholder="City"                            
                            required
                            class:is-invalid='{obj.physical_city == null}'
                        />                    
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='physical_postcode'>
                        Postcode <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.physical_postcode}                            
                            placeholder="Postcode"                            
                            required
                            class:is-invalid='{obj.physical_postcode == null}'
                        />                    
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='postcode'>
                        Province <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>    
                        {#if showPhysicalProvince === false}
                            <div class='clearfix'>
        
                                <button type='button' class='btn btn-outline-primary btn-sm float-end ms-2' on:click={() => showPhysicalProvince = true}>
                                    <span class='fas fa-edit'></span> Edit Province
                                </button>
        
                                <span class='fas fa-map-marker-alt'></span> { obj.physical_province_name }
        
                            </div>
                        
                        {:else}
                            
                            <div class='list-group' in:fade out:fade>
        
                                {#if obj.physical_province_id != null}
        
                                    <div class='list-group-item text-end'>
                                        <button type='button' class='btn btn-outline-secondary' on:click={() => showPhysicalProvince = false}>
                                            <span class='fas fa-times-circle'></span> Cancel
                                        </button>
                                    </div>
        
                                {/if}
        
                                {#each provinces as po}
        
                                    <div
                                        class='list-group-item js-button'
                                        on:click={() => selectPhysicalProvince(po)}
                                        on:keypress={() => selectPhysicalProvince(po)}
                                        class:active='{obj.physical_province_id == po.id}'
                                        role='button'
                                        tabindex='0'
                                    >
        
                                        {#if obj.physical_province_id == po.id}
                                            
                                            <span class='fas fa-check-circle me-2' in:fade out:fade></span>
        
                                        {/if}
        
                                        { po.title }
        
                                    </div>
        
                                {/each}
        
                            </div>   
                            
                        {/if}
        
                    </div>
                </div>
                <div class='row mb-3'>
                    <label class='col-sm-3 col-form-label' for='physical_country'>
                        Country <span class='fas fa-asterisk text-danger'></span>
                    </label>
                    <div class='col-sm-9'>                    
                        <input 
                            type='text'
                            class='form-control'
                            bind:value={obj.physical_country}                            
                            placeholder="Optional Country"    
                            required
                            class:is-invalid='{obj.physical_country == null}'                        
                        />                    
                    </div>
                </div>
            </div>

        {/if}

    </fieldset>
    <fieldset>
        <legend>
            Save
        </legend>
        <div class='row mb-3'>
            <div class='col-sm-9 offset-sm-3'>
                <div class='d-grid'>
                    <button type='submit' class='btn btn-outline-primary'>
                        <span class='fas fa-save'></span> Create Booking
                    </button>
                </div>
            </div>
        </div>
    </fieldset>
</form>